import { useEffect } from 'react';
import Layout from '@/components/feature/Layout';
import Hero from '@/pages/home/components/Hero';
import TrendSection from '@/pages/home/components/TrendSection';
import GridSection from '@/pages/home/components/GridSection';
import MethodSection from '@/pages/home/components/MethodSection';
import FaqSection from '@/pages/home/components/FaqSection';
import { events } from '@/mocks/events';
import { setPageMeta, injectJsonLd, clearJsonLd, buildWebSiteLd, SITE_BASE } from '@/utils/seo';

const itemListLd = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: '吃瓜事件时间轴最新收录',
  itemListElement: events.map((e, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: e.title,
    url: `${SITE_BASE}/event/${e.id}`,
  })),
};

export default function Home() {
  useEffect(() => {
    setPageMeta({
      title: '吃瓜事件时间轴持续更新 - 瓜迹热点追踪',
      description:
        '瓜迹按节点梳理每起热点事件的经过与进展，从爆发、发酵、关键回应到后续追踪一目了然。追更最新吃瓜动态，看事件如何一步步演变，时间线持续更新。',
      keywords: '吃瓜事件,吃瓜事件时间轴,吃瓜事件节点,吃瓜事件经过,吃瓜事件进展,热点追踪',
      path: '/',
    });
    const c1 = injectJsonLd(buildWebSiteLd());
    const c2 = injectJsonLd(itemListLd);
    return () => {
      clearJsonLd();
      c1();
      c2();
    };
  }, []);

  return (
    <Layout>
      <Hero />
      <TrendSection />
      <GridSection />
      <MethodSection />

      {/* CTA 横幅 */}
      <section className="relative overflow-hidden bg-primary-600">
        <div className="pointer-events-none absolute inset-0 opacity-10">
          <i className="ri-node-tree absolute -left-6 top-6 text-8xl" />
          <i className="ri-question-mark absolute right-10 top-4 text-7xl" />
          <i className="ri-focus-3-line absolute bottom-2 left-1/2 text-6xl" />
        </div>
        <div className="relative mx-auto flex max-w-7xl flex-col items-center px-4 py-12 text-center md:px-6">
          <h2 className="font-heading text-2xl font-semibold text-background-50 md:text-3xl">看到一件新热事？先别急着下定论</h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
            来瓜迹顺着时间轴看完全程：官方怎么说、进展到哪一步、后续怎么变，都在一条线里说清楚。
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a
              href="/events"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              浏览全部事件时间轴 <i className="ri-arrow-right-line" />
            </a>
            <a
              href="mailto:hello@guaji.team"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-mail-send-line" /> 反馈新线索
            </a>
          </div>
        </div>
      </section>

      <FaqSection />
    </Layout>
  );
}